// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__2tT6G"};